<script>
import MetisMenu from "metismenujs/dist/metismenujs";
import SearchAuditService from "@/services/searchAudit";

/**
 * Sidenav component
 */
export default {
    data() {
        return {
            menuRef: null,
            // counts for items with a badgeKey (e.g. pending search suggestions)
            dynamicBadges: {},
        };
    },
    mounted: function () {
        this.menuRef = new MetisMenu("#side-menu");
        this.highlightActiveItem();
        this.loadDynamicBadges();
        this.$root.$on("search-improvements-changed", this.loadDynamicBadges);
    },
    beforeDestroy() {
        this.$root.$off("search-improvements-changed", this.loadDynamicBadges);
    },
    methods: {
        loadDynamicBadges() {
            // the entry can be top-level or a Go Search sub-item
            const all = (this.items || []).flatMap((item) => [item, ...((item && item.subItems) || [])]);
            const wants = all.some((item) => item && item.badgeKey === "search_improvements");
            const projectId = sessionStorage.getItem("current_project");
            if (!wants || !projectId) return;
            SearchAuditService.getSummary(projectId)
                .then((summary) => { this.$set(this.dynamicBadges, "search_improvements", summary.pending || 0); })
                .catch(() => { this.$set(this.dynamicBadges, "search_improvements", 0); });
        },

        isExternalLink(link) {
            if (!link) return false;
            return /^https?:\/\//.test(link);
        },
        /**
         * Returns true or false if given menu item has child or not
         * @param item menuItem
         */
        hasItems(item) {
            return item.subItems !== undefined ? item.subItems.length > 0 : false;
        },

        toggleMenu(event) {
            event.currentTarget.nextElementSibling.classList.toggle("mm-show");
        },
        reloadMenu(){
            this.menuRef?.dispose();
            // Limpiar antes de crear la instancia: su init() anima cualquier
            // submenú que encuentre activo, y si después lo limpiamos a mitad de
            // la animación queda con isTransitioning = true e ignora los clicks.
            this.clearActiveItem();
            this.menuRef = new MetisMenu("#side-menu");
            this.highlightActiveItem();
        },
        /**
         * El menú ya no se vuelve a montar al navegar (el layout vive en App.vue),
         * así que antes de marcar la ruta actual se limpia lo que quedó marcado
         * de la anterior. Deja el menú como lo dejaba un montaje nuevo.
         */
        clearActiveItem() {
            const menu = document.getElementById("side-menu");
            if (!menu) return;
            menu.querySelectorAll(".active").forEach((el) => el.classList.remove("active"));
            menu.querySelectorAll(".mm-active").forEach((el) => el.classList.remove("mm-active"));
            menu.querySelectorAll(".mm-show").forEach((el) => el.classList.remove("mm-show"));
            // Si se navega en medio de la animación de un submenú, el transitionend
            // no llega y MetisMenu no vuelve a abrir un ul que sigue "colapsando".
            menu.querySelectorAll("ul.sub-menu").forEach((ul) => {
                ul.classList.remove("mm-collapsing");
                ul.classList.add("mm-collapse");
                ul.style.height = "";
            });
        },
        highlightActiveItem() {
        var links = document.getElementsByClassName("side-nav-link-ref");
        var matchingMenuItem = null;
        const paths = [];

        for (var i = 0; i < links.length; i++) {
            // Solo agregar pathname si existe (ignorar links externos)
            if (links[i]["pathname"]) {
                paths.push(links[i]["pathname"]);
            }
        }
        var itemIndex = paths.indexOf(window.location.pathname);
        if (itemIndex === -1) {
            const strIndex = window.location.pathname.lastIndexOf("/");
            const item = window.location.pathname.substr(0, strIndex).toString();
            const foundIndex = paths.indexOf(item);
            if (foundIndex !== -1) {
                // Buscar el link correspondiente en el array original
                let linkIndex = 0;
                for (var j = 0; j < links.length; j++) {
                    if (links[j]["pathname"] === item) {
                        linkIndex = j;
                        break;
                    }
                }
                matchingMenuItem = links[linkIndex];
            }
        } else {
            // Buscar el link correspondiente en el array original
            let linkIndex = 0;
            let pathCount = 0;
            for (var k = 0; k < links.length; k++) {
                if (links[k]["pathname"]) {
                    if (pathCount === itemIndex) {
                        linkIndex = k;
                        break;
                    }
                    pathCount++;
                }
            }
            matchingMenuItem = links[linkIndex];
        }

        if (matchingMenuItem) {
            matchingMenuItem.classList.add("active");
            var parent = matchingMenuItem.parentElement;

            /**
             * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
             * We should come up with non hard coded approach
             */
            if (parent) {
                parent.classList.add("mm-active");
                const parent2 = parent.parentElement.closest("ul");
                if (parent2 && parent2.id !== "side-menu") {
                    parent2.classList.add("mm-show");

                    const parent3 = parent2.parentElement;
                    if (parent3) {
                        parent3.classList.add("mm-active");
                        var childAnchor = parent3.querySelector(".has-arrow");
                        var childDropdown = parent3.querySelector(".has-dropdown");
                        if (childAnchor) childAnchor.classList.add("mm-active");
                        if (childDropdown) childDropdown.classList.add("mm-active");

                        const parent4 = parent3.parentElement;
                        if (parent4 && parent4.id !== "side-menu") {
                            parent4.classList.add("mm-show");
                            const parent5 = parent4.parentElement;
                            if (parent5 && parent5.id !== "side-menu") {
                                parent5.classList.add("mm-active");
                                const childanchor = parent5.querySelector(".is-parent");
                                if (childanchor && parent5.id !== "side-menu") {
                                    childanchor.classList.add("mm-active");
                                }
                            }
                        }
                    }
                }
            }
        }
        },
    },
    props:{
        items: {
            type: Array
        }
    },
    watch: {
      $route() {
        this.$nextTick(() => this.reloadMenu());
        this.loadDynamicBadges();
      },
      items: {
        immediate: true,
        handler(newVal){
            if(newVal && newVal.length > 0){
                setTimeout(()=>{
                    this.reloadMenu();
                },1000)
            }
        }
      }  
    }
};
</script>

<template>
<!-- ========== Left Sidebar Start ========== -->

<!--- Sidemenu -->
<div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="list-unstyled">
        <template v-for="item in items">
            <li class="menu-title" v-if="item.isTitle" :key="item.id">
                {{ $t(item.label) }}
            </li>
            <li v-if="!item.isTitle && !item.isLayout" :key="item.id">
                <a v-if="hasItems(item)" href="javascript:void(0);" class="is-parent" :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }">
                    <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
                    <img :src="item.image" alt height="17" style="opacity: 0.5; margin-right: 10px;" v-if="item.image" />
                    <span>{{ $t(item.label) }}</span>
                    <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">{{ $t(item.badge.text) }}</span>
                </a>

                <router-link :to="item.link" v-if="!hasItems(item) && !isExternalLink(item.link)" class="side-nav-link-ref">
                    <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
                    <img :src="item.image" alt height="17" style="opacity: 0.5; margin-right: 10px;" v-if="item.image" />
                    <span>{{ $t(item.label) }}</span>
                    <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">{{ $t(item.badge.text) }}</span>
                    <span class="badge rounded-pill bg-danger float-end" v-if="item.badgeKey && dynamicBadges[item.badgeKey]">{{ dynamicBadges[item.badgeKey] }}</span>
                </router-link>

                <a 
                    v-if="!hasItems(item) && isExternalLink(item.link)" 
                    :href="item.link" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    class="side-nav-link-ref">
                    <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
                    <img :src="item.image" alt height="17" style="opacity: 0.5; margin-right: 10px;" v-if="item.image" />
                    <span>{{ $t(item.label) }}</span>
                    <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">{{ $t(item.badge.text) }}</span>
                </a>

                <ul v-if="hasItems(item)" class="sub-menu mm-collapse" aria-expanded="false">
                    <li v-for="(subitem, index) of item.subItems" :key="index">
                        <router-link 
                            :to="subitem.link" 
                            v-if="!hasItems(subitem) && !isExternalLink(subitem.link)" 
                            class="side-nav-link-ref">
                            {{ $t(subitem.label) }}
                            <span class="badge rounded-pill bg-danger float-end" v-if="subitem.badgeKey && dynamicBadges[subitem.badgeKey]">{{ dynamicBadges[subitem.badgeKey] }}</span>
                        </router-link>
                        <a 
                            :href="subitem.link" 
                            v-if="!hasItems(subitem) && isExternalLink(subitem.link)" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            class="side-nav-link-ref">
                            {{ $t(subitem.label) }}
                        </a>
                        <a v-if="hasItems(subitem)" class="side-nav-link-a-ref has-arrow" href="javascript:void(0);">{{ $t(subitem.label) }}</a>
                        <ul v-if="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                            <li v-for="(subSubitem, index) of subitem.subItems" :key="index">
                                <router-link 
                                    :to="subSubitem.link" 
                                    v-if="!isExternalLink(subSubitem.link)"
                                    class="side-nav-link-ref">
                                    {{ $t(subSubitem.label) }}
                                </router-link>
                                <a 
                                    :href="subSubitem.link" 
                                    v-if="isExternalLink(subSubitem.link)"
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    class="side-nav-link-ref">
                                    {{ $t(subSubitem.label) }}
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </template>
    </ul>
</div>
<!-- Sidebar -->
</template>

<style scoped>
     #sidebar-menu ul li a {
       padding: .35rem 1.5rem !important;
    } 

    #sidebar-menu ul li ul.sub-menu li a {
        padding: 0.4rem 1.5rem 0.4rem 3.5rem !important;
    }
    
    .mm-active img {
        opacity: 1 !important;
    }
</style>
